import { BasketballLeaguesSlice } from '@hefe/store';
import { Radio, Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import { useAppDispatch } from '../../../../store/store';

export default function AddLeagueAssistentCountry() {
  const dispatch = useAppDispatch();

  const selectCountry = (country: string) => {
    dispatch(
      BasketballLeaguesSlice.basketballLeaguesActions.setSelectedCountry(
        country
      )
    );
  };

  return (
    <Space direction="vertical" align="center" style={{ width: '100%' }}>
      <Typography.Paragraph>
        {t('leagues.assistant.select_country.question')}
      </Typography.Paragraph>
      <Space direction="vertical" align="center">
        <Radio.Group
          defaultValue="a"
          size="large"
          onChange={(event) => selectCountry(event.target.value)}
        >
          <Radio.Button value="de">
            <span role="img" aria-label="de">
              🇩🇪 {t('leagues.assistant.select_country.germany')}
            </span>
          </Radio.Button>
          <Radio.Button value="ch" disabled>
            <span role="img" aria-label="ch">
              🇨🇭 {t('leagues.assistant.select_country.switzerland')}
            </span>
          </Radio.Button>
        </Radio.Group>
      </Space>
    </Space>
  );
}
